import React from "react"
import "./style.scss"

export function Sectors(props) {
  const { sectors } = props
  return (
    <ul className="sector-list">
      <li>
        <strong className="sector-bullet">Sectors: </strong>
      </li>
      {sectors.map((sector, index) => {
        return <li key={index}>{sector.name}</li>
      })}
    </ul>
  )
}
